'use client'
import { useWindowDimensions } from '@/hooks/client/use-window-dimensions'

// Must match the `nav` screen in tailwind.config.mjs. Below this width the CSS
// hides the desktop menu (`nav:flex`) and shows the hamburger, so the nav is in
// its mobile presentation.
//
// The nav used to read `useIsMediumOrMobileView()` (<= 991px) for this, which
// left a 79px band — 992px to 1069px — where CSS had switched to the hamburger
// but JS still believed it was desktop. In that band the hamburger rendered the
// wrong toggle icon and large custom-link cards laid out as wide rows inside the
// mobile drawer. Keep this constant and the Tailwind `nav` screen in sync.
const NAV_MOBILE_MAX_WIDTH = 1069

/** True when the nav is showing its mobile (hamburger + drawer) presentation. */
export const useIsNavMobileView = (): boolean => {
  const { width } = useWindowDimensions(true)
  return width === null ? false : width <= NAV_MOBILE_MAX_WIDTH
}
